import type { ScratchState, ScratchTile } from '@goodtime/shared';
import type { GameView } from './core';

export type ScratchView = GameView<ScratchState, ScratchTile[]>;

/** The picture under tile `index`, once uncovered. */
export const tileAt = (view: ScratchView, index: number): number | null =>
  view.state?.uncovered.find((t) => t.index === index)?.picture ?? null;

export const canScratch = (view: ScratchView, index: number): boolean =>
  view.phase === 'play' && tileAt(view, index) === null;

/** The tiles of the winning three, to light up. */
export function winningTiles(view: ScratchView): number[] {
  const s = view.state;
  if (!s || s.won === null) return [];
  return s.uncovered.filter((t) => t.picture === s.won).map((t) => t.index);
}

/** What an uncovered tile is worth, said on a tap. */
export const scratchTileExplain = (coins: number): string =>
  `Three of these win ${coins.toLocaleString('en-GB')} coins.`;

/** A loss is said plainly before anything else (producer 2026-10-14). */
export function scratchLead(view: ScratchView): string {
  if (view.phase === 'over') return view.state?.won !== null && view.state?.won !== undefined ? 'Three of a kind!' : 'No three of a kind this time.';
  return 'Scratch the tiles. Three of a kind wins that prize.';
}
